import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { hideError, OrderExceptionCode, useDispatch } from "@jti/store";
import { MagentoOrderCreationErrorView } from "./MagentoOrderCreationErrorView";
import { PGSErrorView } from "./PGSErrorView";
import styles from "./OrderErrorView.module.scss";
export const OrderErrorView = ({ exception, className }) => {
    const dispatch = useDispatch();
    function getOrderErrorView({ code }) {
        switch (code) {
            case OrderExceptionCode.PGSIssue:
                return _jsx(PGSErrorView, {});
            case OrderExceptionCode.MagentoOrderCreationIssue:
                return _jsx(MagentoOrderCreationErrorView, {});
            //unsupported exceptioon
            default:
                dispatch(hideError());
                throw Error("Unsupported exception type");
        }
    }
    if (exception === null)
        return _jsx(_Fragment, {});
    try {
        const exceptionView = getOrderErrorView(exception);
        return _jsx("div", { className: classNames(styles.errorContainer, className), children: exceptionView });
    }
    catch (e) {
        return _jsx(_Fragment, {});
    }
};
//# sourceMappingURL=OrderErrorView.js.map